import { TreeSelect } from '@/ui/Select'
import { Routes } from './components/Routes'
import { useWorkstationSelectPM } from '../hooks/useWorkstationSelectPM'
import { DateInputPM } from '@/components/DateInput'

import styles from './Workstation.module.scss'

export const WorkstationPM = () => {
    const { options, selectedValue, handleWorkstationChange } = useWorkstationSelectPM()

    return (
        <div className={styles.root}>
            <div className={styles.header}>
                <TreeSelect
                    placeholder="Workstation"
                    options={options}
                    value={selectedValue}
                    disabled={!options.length}
                    onChange={handleWorkstationChange}
                />
                <DateInputPM />
            </div>
            <Routes isEditable={false} />
        </div>
    )
}
